import BoardTool from '@/components/common/ed-board/ed-board-tools/board-tool.interface';
import WboDrawerTools from '@/components/common/ed-board/ed-board-tools/ed-wbo-drawer/wbo-drawer-tools';
import { _HOMEWORKS_STORE } from '@/homework/values/homeworks.values';
import { Store } from 'vuex';

/********************************** WHITEBOPHIR ***************************************************
 * This class was taken and adapted for the EDUAC project from the WHITEBOPHIR project            *
 * https://github.com/lovasoa/whitebophir, keeping the same distribution and license conditions.  *
 **************************************************************************************************
 */
export default class EdWboDrawerHand {

    private selected: any = null;
    private last_sent: number = 0;
    private wboDrawerTools: WboDrawerTools;
    private setCursorBoardMutation: any;

    private startMovingElement: Function = (x: number, y: number, evt: any) => {        
        //Prevent the press from being interpreted by the browser
        evt.preventDefault();
   
        if (evt.target !== this.wboDrawerTools.svg && !this.wboDrawerTools.annotations.includes(evt.target.id) 
            && !this.wboDrawerTools.isHostUser) {            
            return;
        }

        if (!evt.target || !this.wboDrawerTools.drawingArea.contains(evt.target)) {            
            return;
        }  
        let tmatrix = this.get_translate_matrix(evt.target);
        this.selected = {
            x: x - tmatrix.e, y: y - tmatrix.f, elem: evt.target
        };
    }

    private moveElement: Function = (x: number, y: number) => {        
        if (!this.selected) {
            return
        }
        let deltax = x - this.selected.x;
        let deltay = y - this.selected.y;
        let msg = {type: 'update', id: this.selected.elem.id, deltax: deltax, deltay: deltay};
        let now = performance.now();
        if (now - this.last_sent > 70) {
            this.last_sent = now;
            this.wboDrawerTools.drawAndSend(msg);
        } else {
            this.draw(msg);
        }
    }

    private get_translate_matrix: Function = (elem: any) => {
        // Returns the first translate or transform matrix or makes one
        let translate = null;
        for (let i: number = 0; i < elem.transform.baseVal.numberOfItems; ++i) {
            let baseVal = elem.transform.baseVal[i];
            // quick tests showed that even if one changes only the fields e and f or uses createSVGTransformFromMatrix
            // the brower may add a SVG_TRANSFORM_MATRIX instead of a SVG_TRANSFORM_TRANSLATE
            if (baseVal.type === SVGTransform.SVG_TRANSFORM_TRANSLATE || baseVal.type === SVGTransform.SVG_TRANSFORM_MATRIX) {
                translate = baseVal;
                break;
            }
        }
        if (translate == null) {
            translate = elem.transform.baseVal.createSVGTransformFromMatrix(this.wboDrawerTools.svg.createSVGMatrix());
            elem.transform.baseVal.appendItem(translate);
        } else {
            setTimeout(() => {
                this.wboDrawerTools.svg.querySelector(`#${elem.id}`)
                    .setAttribute('transform', 'matrix(' + translate.matrix.a + ','
                        + translate.matrix.b + ',' + translate.matrix.c + ',' + translate.matrix.d + ','
                        + translate.matrix.e + ',' + translate.matrix.f + ')');
            }, 1)
        }
        return translate.matrix;
    }

    private draw: Function = (data: any, isMadeByUser: boolean = true) => {
        switch (data.type) {
            case 'update': {
                if (isMadeByUser && !this.wboDrawerTools.isHostUser && this.wboDrawerTools.annotationOwners[data.id]?.userName !== this.wboDrawerTools.username) {
                    // If the update is made by the user, he can't move elements that are not owned by him, unless he's a host
                    return false;
                }
                let elem = this.wboDrawerTools.svg.getElementById(data.id);
                if (!elem) {
                    throw new Error('Mover: Tried to move an element that does not exist.');
                }
                let tmatrix = this.get_translate_matrix(elem);
                tmatrix.e = data.deltax || 0;
                tmatrix.f = data.deltay || 0;
                break;
            }
            default:
                throw new Error(`Mover: 'move' instruction with unknown type:  ${data}`);
        }
        return true;
    }

    private startHand: Function = (x: number, y: number, evt: any, isTouchEvent: boolean) => {
        if (!isTouchEvent) {
            this.selected = {
                x: document.documentElement.scrollLeft + evt.clientX,
                y: document.documentElement.scrollTop + evt.clientY
            }
        }
    }

    private moveHand: Function = (x: number, y: number, evt: any, isTouchEvent: boolean) => {
        /* Function disabled to don't move the board*/
    }

    private press: Function = (x: number, y: number, evt: any, isTouchEvent: boolean) => {
        if(this.setCursorBoardMutation) {
            this.setCursorBoardMutation(false);
        } 
        if (!this.handTool.secondary.active) {
            this.startHand(x, y, evt, isTouchEvent);
        } else {
            this.startMovingElement(x, y, evt, isTouchEvent);
        }
    }

    private move: Function = (x: number, y: number, evt: any, isTouchEvent: boolean) => {
        if (!this.handTool.secondary.active) {
            this.moveHand(x, y, evt, isTouchEvent);
        } else {
            this.moveElement(x, y, evt, isTouchEvent);
        }
    }

    private release: Function = (x: number, y: number, evt: any, isTouchEvent: boolean) => {
        this.move(x, y, evt, isTouchEvent);
        if (this.selected && this.wboDrawerTools.stopStrokeCallback) {
            this.wboDrawerTools.stopStrokeCallback();
        }
        this.selected = null;
        if(this.setCursorBoardMutation)
            this.setCursorBoardMutation(true);
    }

    private switchTool: Function = () => {
        this.selected = null;
    }


    private handTool: BoardTool = { //The new tool
        name       : 'Hand',
        shortcut   : 'h',
        listeners  : {
            press  : this.press,
            move   : this.move,
            release: this.release
        },
        secondary  : {
            name  : 'Mover',
            icon  : '/assets/tools/hand/mover.svg',
            active: false,
            switch: this.switchTool
        },
        draw       : this.draw,
        icon       : '/assets/tools/hand/hand.svg',
        mouseCursor: 'move',
        showMarker : true
    };

    constructor(tools: WboDrawerTools, setCursorBoardMutation: any = null) {
        this.wboDrawerTools = tools;
        this.setCursorBoardMutation = setCursorBoardMutation;
        this.wboDrawerTools.add(this.handTool);
        tools.changeTool('Hand');
    }
}